/* eslint-disable import/prefer-default-export */

export const FBUY_COOKIE_NAME = 'friendbuy_referral_code';
export const FBUY_QUERY_PARAM = 'fbuy_ref_code';

export const friendbuyCode = state => state.request.query[FBUY_QUERY_PARAM] || state.request.cookies[FBUY_COOKIE_NAME];
